import { dmApi } from "../../../app/dmApi";
import { serialize } from "../../../helpers/Utils";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";

export const suppliersApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        searchSuppliers: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/supplier?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['suppliers'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createSupplier: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/supplier/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['suppliers'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Supplier")
            },
        }),
        getSupplierById: build.query({
            query: (id) => {
                return {
                    url: `/supplier/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['supplierById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateSupplier: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/supplier/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['suppliers', 'supplierById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Supplier")
            },
        }),
        removeSupplier: build.mutation({
            query: (id) => {
                return {
                    url: `/supplier/delete/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Removed", "Supplier")
            },
            invalidatesTags: ['suppliers']
        }),
    }),
});


export const {
    useCreateSupplierMutation,
    useSearchSuppliersQuery,
    useUpdateSupplierMutation,
    useRemoveSupplierMutation
} = suppliersApi;